import React, { useState } from "react";
import Navbar from "../components/partial/Navbar";
import Footer from "../components/partial/Footer";
import banner from "../asset/contact-banner.png";
import { FaPhoneAlt } from "react-icons/fa";
import { IoMdHome } from "react-icons/io";
import { MdOutlineLocalPostOffice } from "react-icons/md";
import toast, { Toaster } from "react-hot-toast";
import { API_URL, contactapi } from "../../constant";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      name: "",
      email: "",
      phone: "",
    };

    const nameRegex = /^[A-Za-z\s]+$/;
    if (!formData.name.match(nameRegex)) {
      newErrors.name = "Name should contain only letters and spaces";
      isValid = false;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.match(emailRegex)) {
      newErrors.email = "Please enter a valid email address";
      isValid = false;
    }

    const phoneRegex = /^\d{10}$/;
    if (!formData.phone.match(phoneRegex)) {
      newErrors.phone = "Please enter a valid 10-digit phone number";
      isValid = false;
    }
   
    setErrors(newErrors);
    return isValid;
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    // Phone number sanitization
    if (name === "phone") {
      const sanitizedValue = value.replace(/\D/g, '').slice(0, 10);
      setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
      return;
    }

    // Name validation while typing
    if (name === "name" && !/^[A-Za-z\s]*$/.test(value)) return;

    setFormData(prev => ({ ...prev, [name]: value }));

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Object.values(formData).some(field => field === "")) {
      toast.error("All fields are required");
      return;
    }

    if (!validateForm()) {
      toast.error("Please fix the validation errors");
      return;
    }



    try {
      const response = await fetch(`${API_URL}${contactapi}/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        toast.success("Message sent successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        toast.error("Failed to send message. Please try again later");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred. Please try again later");
    }
  };

  return (
    <>
      <Toaster position="top-right" />
      <Navbar />
      <div className="hero_banner">
        <img src={banner} alt="Contact Banner" className="w-100 h-100" />
        <div className="banner_content pt-md-5 pt-0  position-absolute start-0 w-100 overflow-hidden pt-lg-5">
          <div className="container">
            <div className="row">
              <h1 className="text-white fw-bold banner-text" data-aos="fade-up">
                Contact
              </h1>
              <h3
                className="fw-normal banner-text text-white"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                Unforgettable experience for every explorer
              </h3>
            </div>
          </div>
        </div>
      </div>

      <section className="mt-5 container">
        <div className="row">
          {/* Left Side - Contact Info */}
          <div className="col-lg-6">
            <h2>
              <span className="text-warning">Connect</span> with Our Team <br />
              to Assist You
            </h2>
            <p className="mt-5">
              At GumneJao, we want your travel experience to be smooth and unforgettable! Whether you have a question, need assistance, or want to plan your next trip, feel free to reach out. Our team is always ready to help you with the best travel solutions.
            </p>

            <div className="d-flex align-items-start mb-4">
              <div className="contact-icon">
                <IoMdHome />
              </div>
              <div className="ms-3">
                <p className="contact-title mb-0">Office</p>
                <p className="contact-text">
                  303, Tower 4, Assotech Business Cresterra, Sector 135, Noida
                  201305
                </p>
              </div>
            </div>

            <div className="d-flex align-items-start mb-4">
              <div className="contact-icon me-3">
                <FaPhoneAlt />
              </div>
              <div>
                <p className="contact-title mb-0">Mobile</p>
                <p className="contact-text">+91 9873018222</p>
              </div>
            </div>

            <div className="d-flex align-items-start">
              <div className="contact-icon me-3">
                <MdOutlineLocalPostOffice />
              </div>
              <div>
                <p className="contact-title mb-0">Email</p>
                <p className="contact-text">travanshholidays@gmail.com</p>
              </div>
            </div>
          </div>

          {/* Right Side - Contact Form */}
          <div className="col-lg-6">
            <form
              className="p-3 rounded-3 banner_form contact_form m-auto w-100"
              onSubmit={handleSubmit}
            >
              <h4 className="text-warning">Contact Us</h4>
              <p className="text-white">
                Leave your message & we will get back to you shortly.
              </p>

              <div className="row gy-2">
                <div className="col-12">
                  <label htmlFor="name" className="d-block text-white">
                    Full Name
                  </label>
                  <input
                    type="text"
                    className="w-100 rounded-2 py-1 ps-2"
                    placeholder="Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
             {errors.name && <div className="text-danger small">{errors.name}</div>}

                </div>

                <div className="col-12">
                  <label htmlFor="email" className="d-block text-white">
                    Email ID
                  </label>
                  <input
                    type="email"
                    className="w-100 rounded-2 py-1 ps-2"
                    placeholder="eg@gmail.com"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />

                 {errors.email && <div className="text-danger small">{errors.email}</div>}
                </div>

                <div className="col-12">
                  <label htmlFor="phone" className="d-block text-white">
                    Mobile No.
                  </label>
                  <input
                    type="text"
                    className="w-100 rounded-2 py-1 ps-2"
                    maxLength={10}
                    placeholder="+91 0000000000"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />

{errors.phone && <div className="text-danger small">{errors.phone}</div>}

                </div>

                <div className="col-12">
                  <label htmlFor="message" className="d-block text-white">
                    Message
                  </label>
                  <textarea
                    className="w-100 rounded-2 py-1 ps-2"
                    placeholder="Hello"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>

                <div className="col-12">
                  <button
                    type="submit"
                    className="button border-0 w-100 py-2 rounded-2"
                  >
                    SUBMIT
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Contact;
